import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadNcremTerminListStatus: 'idle',
    loadNcremTerminListError: undefined as any,
    loadNcremTerminListLastArgs: undefined as any,
    loadNcremTerminStatus: 'idle',
    loadNcremTerminError: undefined as any,
    saveNcremTerminStatus: 'idle',
    saveNcremTerminError: undefined as any,
    deleteNcremTerminStatus: 'idle',
    deleteNcremTerminError: undefined as any,

    ncremTerminList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadNcremTerminList = createAsyncThunk('meldungNcremTerminSlice/loadNcremTerminList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungNcremTerminSlice.loadNcremTerminListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadNcremTerminListStatus } = getState().meldungNcremTerminSlice
        return loadNcremTerminListStatus !== 'pending'
    }
})

export const loadNcremTermin = createAsyncThunk('meldungNcremTerminSlice/loadNcremTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadNcremTerminStatus } = getState().meldungNcremTerminSlice
        return loadNcremTerminStatus !== 'pending'
    }
})

export const saveNcremTermin = createAsyncThunk('meldungNcremTerminSlice/saveNcremTermin', async ({ ncremTermin }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ncremTermin?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremtermin/${ ncremTermin?.HDR_ID }/`,
            prepareData(ncremTermin),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremtermin/`,
            prepareData(ncremTermin),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveNcremTerminStatus } = getState().meldungNcremTerminSlice
        return saveNcremTerminStatus !== 'pending'
    }
})

export const deleteNcremTermin = createAsyncThunk('meldungNcremTerminSlice/deleteNcremTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremtermin/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteNcremTerminStatus } = getState().meldungNcremTerminSlice
        return deleteNcremTerminStatus !== 'pending'
    }
})

const NcremTerminSlice = createSlice({
    name: 'meldungNcremTerminSlice',
    initialState,
    reducers: {
        resetloadNcremTerminListError: (state) => {
            state.loadNcremTerminListError = undefined
        },
        resetloadNcremTermin: (state) => {
            state.formItem = undefined
            state.loadNcremTerminError = undefined
        },
        resetloadNcremTerminError: (state) => {
            state.loadNcremTerminError = undefined
        },
        resetsaveNcremTermin: (state) => {
            state.formItem = undefined
            state.saveNcremTerminError = undefined
        },
        resetsaveNcremTerminError: (state) => {
            state.saveNcremTerminError = undefined
        },
        resetdeleteNcremTerminError: (state) => {
            state.deleteNcremTerminError = undefined
        },
        removeFromNcremTerminListById: (state, action) => {
            state.ncremTerminList = state.ncremTerminList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromNcremTerminListByIds: (state, action) => {
            state.ncremTerminList = state.ncremTerminList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ncremTerminList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadNcremTerminListStatus = 'preloaded'
            state.loadNcremTerminListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ncremTerminList = []
            state.loadNcremTerminListStatus = 'idle'
            state.loadNcremTerminListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadNcremTerminList.pending, (state) => {
            state.loadNcremTerminListStatus = 'pending'
            state.loadNcremTerminListError = undefined
        })
        builder.addCase(loadNcremTerminList.fulfilled, (state, action) => {
            state.loadNcremTerminListStatus = 'idle'

            if (!action.payload) { return }

            state.loadNcremTerminListLastArgs = action.payload.args

            {
                state.ncremTerminList = action.payload.data

            }
        })
        builder.addCase(loadNcremTerminList.rejected, (state, action) => {
            state.loadNcremTerminListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadNcremTerminListError = action.error.message
            } else {
                state.loadNcremTerminListError = action.payload
            }
        })

        builder.addCase(loadNcremTermin.pending, (state) => {
            state.loadNcremTerminStatus = 'pending'
            state.loadNcremTerminError = undefined
        })
        builder.addCase(loadNcremTermin.fulfilled, (state, action) => {
            state.loadNcremTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ncremTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ncremTerminList.push(newItem) }
                else { state.ncremTerminList[i] = { ...state.ncremTerminList[i], ...newItem } }
            }
        })
        builder.addCase(loadNcremTermin.rejected, (state, action) => {
            state.loadNcremTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadNcremTerminError = action.error.message
            } else {
                state.loadNcremTerminError = action.payload
            }
        })

        builder.addCase(saveNcremTermin.pending, (state) => {
            state.saveNcremTerminStatus = 'pending'
            state.saveNcremTerminError = undefined
        })
        builder.addCase(saveNcremTermin.fulfilled, (state, action) => {
            state.saveNcremTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ncremTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ncremTerminList.push(newItem) }
                else { state.ncremTerminList[i] = { ...state.ncremTerminList[i], ...newItem } }
            }
        })
        builder.addCase(saveNcremTermin.rejected, (state, action) => {
            state.saveNcremTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveNcremTerminError = action.error.message
            } else {
                state.saveNcremTerminError = action.payload
            }
        })

        builder.addCase(deleteNcremTermin.pending, (state) => {
            state.deleteNcremTerminStatus = 'pending'
            state.deleteNcremTerminError = undefined
        })
        builder.addCase(deleteNcremTermin.fulfilled, (state, action) => {
            state.deleteNcremTerminStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ncremTerminList = state.ncremTerminList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ncremTerminList = state.ncremTerminList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteNcremTermin.rejected, (state, action) => {
            state.deleteNcremTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteNcremTerminError = action.error.message
            } else {
                state.deleteNcremTerminError = action.payload
            }
        })

    }
})

export const {
    resetloadNcremTerminListError,
    resetloadNcremTermin,
    resetloadNcremTerminError,
    resetsaveNcremTermin,
    resetsaveNcremTerminError,
    resetdeleteNcremTerminError,
    removeFromNcremTerminListById,
    removeFromNcremTerminListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = NcremTerminSlice.actions
export default NcremTerminSlice.reducer
